/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
export type IAwardedLaneListItemFragment = { __typename?: 'ShipperRate' } & Pick<
  Types.IShipperRate,
  | 'id'
  | 'deliveryCity'
  | 'deliveryStateCode'
  | 'deliveryRegion'
  | 'endDate'
  | 'isDeliveryDropTrailer'
  | 'isPickupDropTrailer'
  | 'pickupCity'
  | 'pickupStateCode'
  | 'pickupRegion'
  | 'sourcedCarrierRatesCount'
  | 'sourceStatus'
  | 'startDate'
  | 'weeklyVolume'
> & {
    carrierSalesRep?: Types.Maybe<{ __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>>
    deliveryLocation?: Types.Maybe<
      { __typename?: 'Location' } & Pick<Types.ILocation, 'id' | 'city' | 'stateCode'>
    >
    equipment?: Types.Maybe<
      { __typename?: 'Equipment' } & Pick<Types.IEquipment, 'id' | 'key' | 'name' | 'parentKey'> & {
          parent?: Types.Maybe<{ __typename?: 'Equipment' } & Pick<Types.IEquipment, 'id'>>
        }
    >
    pickupLocation?: Types.Maybe<
      { __typename?: 'Location' } & Pick<Types.ILocation, 'id' | 'city' | 'stateCode'>
    >
    shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
      Types.IShipperApplication,
      'id' | 'name'
    >
  }

export const AwardedLaneListItemFragmentDoc = gql`
  fragment AwardedLaneListItem on ShipperRate {
    id
    carrierSalesRep {
      id
      fullName
    }
    deliveryCity
    deliveryStateCode
    deliveryRegion
    deliveryLocation {
      id
      city
      stateCode
    }
    endDate
    equipment {
      id
      key
      name
      parentKey
      parent {
        id
      }
    }
    isDeliveryDropTrailer
    isPickupDropTrailer
    pickupCity
    pickupStateCode
    pickupRegion
    pickupLocation {
      id
      city
      stateCode
    }
    shipperApplication {
      id
      name
    }
    sourcedCarrierRatesCount
    sourceStatus
    startDate
    weeklyVolume
  }
`
